import { render, staticRenderFns } from "./HotelOrderList.vue?vue&type=template&id=be49021e&scoped=true"
import script from "./HotelOrderList.vue?vue&type=script&lang=js"
export * from "./HotelOrderList.vue?vue&type=script&lang=js"
import style0 from "./HotelOrderList.vue?vue&type=style&index=0&id=be49021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be49021e",
  null
  
)

export default component.exports